import { Component, OnInit, Input } from '@angular/core';
import { AmountDto, CurrencyDto } from '@hub/generated/models';

@Component({
  selector: 'g-columnCurrency',
  templateUrl: './columnCurrency.component.html'
})
export class ColumnCurrencyComponent implements OnInit {
  constructor() {}

  @Input() data: any;
  @Input() currency: CurrencyDto = new CurrencyDto();
  @Input() isEditing: boolean = false;

  isAmount: boolean = true;

  ngOnInit() {
    this.isAmount = typeof(this.data) !== 'number';
  }

  public getSymbol(): string {
    if (this.isAmount) {
      return this.data && this.data.Currency && this.data.Currency.Symbol != ''
        ? this.data.Currency.Symbol
        : '$';
    } else {
      return this.currency && this.currency.Symbol && this.currency.Symbol != '' ? this.currency.Symbol : '$ ';
    }
  }
}
